(() => {
  const norm = (s) => (s || "").replace(/\s+/g, " ").trim().toLowerCase();

  // IMPORTANT: only remove in the filters header area (not in product cards)
  const isInFiltersArea = (el) =>
    !!el.closest(
      ".facets, .facets-container, .facets-controls-wrapper, facet-filters, .collection-filters, .collection__filters"
    );

  const isInsideProductCard = (el) =>
    !!el.closest(".product-card, .card-wrapper, .grid__item, .product-badges, .product-grid");

  function removeChip(root) {
    const nodes = root.querySelectorAll("button, a, span, div, li");

    nodes.forEach((el) => {
      if (!isInFiltersArea(el)) return;
      if (isInsideProductCard(el)) return;

      const t = norm(el.textContent);

      // Use contains to catch "Out of stock (1)" etc.
      if (!t.includes("out of stock")) return;

      // Remove the smallest clickable wrapper
      const target = el.closest("button") || el.closest("a") || el.closest("li") || el;

      // Safety: only remove small pills (avoid removing big containers)
      const r = target.getBoundingClientRect?.();
      const looksLikePill = !r || (r.height <= 80 && r.width <= 260);
      if (!looksLikePill) return;

      target.remove();
    });
  }

  function run() {
    removeChip(document);
    document.querySelectorAll("*").forEach((el) => {
      if (el.shadowRoot) removeChip(el.shadowRoot);
    });
  }

  run();

  const obs = new MutationObserver(() => {
    clearTimeout(window.__gesOOS);
    window.__gesOOS = setTimeout(run, 60);
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
